import Pan from './Pan';

export default Pan;